module.exports = __webpack_public_path__ + "static/chunks/src/page-ottawa/part-why-replace/assets/image-cause-02.21f05e549d56e45c85961dc4ac22de19.webp";